package acupoint.containers

import com.jingfangpai.api.clients.AcupointApiClient
import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.common.data.model.IdName
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import react.*
import react.dom.div
import setTitle
import acupoint.components.AcupointInDetail
import com.jingfangpai.acupoint.model.AcupointDetail

external interface AcupointDetailPageProps : RProps {
    var id: String
}

data class AcupointDetailPageContextData(
    var getDetail: (id: String, okCallback: (result: ApiResponse<AcupointDetail>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getComments: (entityType: CommentEntityType, entityId: String, type: CommentType, okCallback: (result: ApiResponse<Array<Comment>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var saveComment: (comment: Comment, okCallback: (result: ApiResponse<Comment>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var listIdAndName: (okCallback: (result: ApiResponse<List<IdName>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit
)

val AcupointDetailPageContext = createContext(AcupointDetailPageContextData(AcupointApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save, AcupointApiClient::listIdAndName))

val AcupointDetailPageProvider = functionalComponent<AcupointDetailPageProps> { props ->

    setTitle("穴位详情")

    useEffectOnce { }

    AcupointDetailPageContext.Provider(AcupointDetailPageContextData(AcupointApiClient::getDetail, CommentApiClient::getComments, CommentApiClient::save, AcupointApiClient::listIdAndName)) {
        div("AcupointDetailPage-page") {
            child(AcupointInDetail) {
                attrs {
                    id = props.id
                }
            }
        }
    }
}
